import React from "react";
import PersonalMessagesVirtualTableHeader from "./components/PersonalMessagesVirtualTableHeader";
import PersonalMessagesVirtualTableRow from "./components/PersonalMessagesVirtualTableRow";
import { useMessageManagementContext } from "../../hooks/MessageManagementContext";
import { VirtualTable } from "../../components/tables";
import { TableRecordCountDisplayFooter } from "../../components/tables/VirtualTable";

const PersonalMessages = () => {
    const {
        clear: refreshTable,
        data,
        error,
        isLoading,
        isNextPageLoading,
        isNewRecords,
        isRowLoaded,
        loadMore,
        newRecordsSinceCache,
        totalCount
    } = useMessageManagementContext()!;
    
    const isNewRecordsDisplayed = isNewRecords && !isLoading && !isNextPageLoading;
    return (
        <VirtualTable 
            enableScrollTracking={false}
            row={PersonalMessagesVirtualTableRow}
            header={<PersonalMessagesVirtualTableHeader />}
            footer={
                <TableRecordCountDisplayFooter 
                    spanRight={6}
                    totalCount={totalCount}
                    isNewRecordsDisplayed={isNewRecordsDisplayed}
                    newRecordsSinceCache={newRecordsSinceCache}
                    reload={refreshTable}
                />
            }
            error={error}
            isLoading={isNextPageLoading}
            isItemLoaded={isRowLoaded}
            loadMoreItems={loadMore}
            itemSize={40}
            itemCount={totalCount}
            itemData={data}
        />
    );
}

export default PersonalMessages;